import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './Table.scss';

export default function Table({ className, caption, compact, striped, children }) {
  const classNames = cn('cp-table', className, {
    'table--compact': compact,
    'table--striped': striped
  });

  return (
    <table className={classNames}>
      {caption && (
        <caption>
          <ScreenReaderMessage role="status" aria-live="polite" aria-atomic="true">
            {caption}
          </ScreenReaderMessage>
        </caption>
      )}
      {children}
    </table>
  );
}

Table.propTypes = {
  className: PropTypes.string,
  caption: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: childrenShape,
  compact: PropTypes.bool,
  striped: PropTypes.bool
};
